import { ref } from "vue";
import { loadProcessorError } from "./BlurProcessor";
import { vbgEngine } from "./vbg/engine";
import { needSync } from "../states/media/pipe";

export const segmenterLoading = ref(false);
export const segmenterReady = ref(false);

/**
 * Прогреть модель в воркере. Повторные вызовы во время загрузки игнорируются, успех будит
 * конвейер через needSync — так videoBlur узнаёт, что процессор можно ставить.
 */
export async function waitSegmenter() {
  if (segmenterLoading.value) return;
  segmenterLoading.value = true;
  try {
    await vbgEngine.ensureReady();
    loadProcessorError.value = false;
    segmenterReady.value = true;
    needSync();
  } catch {
    loadProcessorError.value = true;
  } finally {
    segmenterLoading.value = false;
  }
}
